import { generateCommands } from "../../core/extension";
import { useEffect } from "react";
import { floatingMenuPluginKey, staticMenuPluginKey } from "./state";
import { FormattingToolbarExtension } from "./extension";
const isSameToolbarMode = (plugin, newMode) => {
    const isSameFloating = plugin.spec.key === floatingMenuPluginKey && newMode === "floating";
    const isSameStatic = plugin.spec.key === staticMenuPluginKey && newMode === "static";
    return isSameFloating || isSameStatic;
};
/**
 * Watch toolbar mode prop and reconfigure editor plugins when it changes.
 */
export function useWatchToolbarMode(view, toolBarMode, extensions, portalContainer) {
    useEffect(() => {
        // if toolbar mode is not given as a prop, or view is not set, do nothing
        if (!toolBarMode || !view) {
            return;
        }
        const state = view.state;
        const plugins = state.plugins;
        const schema = state.schema;
        const commands = generateCommands(schema, extensions);
        const thePlugin = plugins.find((plugin) => plugin.spec.key === floatingMenuPluginKey ||
            plugin.spec.key === staticMenuPluginKey);
        if (!thePlugin || isSameToolbarMode(thePlugin, toolBarMode)) {
            return;
        }
        // create a new toolbar extension with the new mode
        const toolbarExtension = new FormattingToolbarExtension({
            mode: toolBarMode,
        });
        // remove old toolbar plugin and add new one
        const newPlugins = toolbarExtension.addPlugins(schema, view.state.plugins.filter((plugin) => plugin !== thePlugin), {
            portalContainer,
            commands,
        });
        // update the state with the new plugins
        const newState = state.reconfigure({
            plugins: newPlugins,
        });
        // update the view with the new state
        view.updateState(newState);
    }, [toolBarMode, view, extensions, portalContainer]);
}
